import React from "react";
import {
    ArrowUpDownIcon,
    FooterInfoSection,
    FooterMiddleSection,
    FooterSectionLabel,
    FooterSectionList,
} from "./FooterStyled";
import PropTypes from "prop-types";
import Anchor from "../../HTMLEntities/Anchor";

class FooterMiddlePart extends React.Component {
    generateFooterMiddlePart() {
        const {isMobile} = this.props;
        return this.props.footerData.map((item, index) => {
            let footerKey = "footerGrp_" + index;
            let accordionClass = this.props.isActive(footerKey) ? "active" : "";
            return (
                <FooterInfoSection key={footerKey}>
                    <FooterSectionLabel onClick={() => this.props.footerHandler(footerKey)}>
                        {item.group}
                        {isMobile && <ArrowUpDownIcon accordionClass={accordionClass} />}
                    </FooterSectionLabel>
                    <FooterSectionList accordionClass={accordionClass}>
                        <ul>
                            {item.gnbFooterLinksData[item.group].map((nestedItem, index) => {
                                return (
                                    <li key={index}>
                                        <Anchor
                                            linkHref={nestedItem.linksUrl}
                                            linkLabel={nestedItem.linksText}
                                            target="_self"
                                            displayStyle={{
                                                laptop: {
                                                    color: "#000",
                                                    marginBottom: "5px",
                                                    display: "inline-block",
                                                    outline: "0px",
                                                    maxWidth: "100%",
                                                    width: "auto",
                                                },
                                                mobile: {
                                                    color: "#000",
                                                    marginBottom: "5px",
                                                    display: "inline-block",
                                                    outline: "0px",
                                                    maxWidth: "100%",
                                                    width: "100%",
                                                },
                                            }}
                                        />
                                    </li>
                                );
                            })}
                        </ul>
                    </FooterSectionList>
                </FooterInfoSection>
            );
        });
    }

    render() {
        const {isMobile} = this.props;
        let footerLeftItems = [];
        if (typeof this.props.footerData != "undefined") {
            footerLeftItems = this.generateFooterMiddlePart(isMobile);
        }

        return <FooterMiddleSection>{footerLeftItems}</FooterMiddleSection>;
    }
}
FooterMiddlePart.propTypes = {
    footerData: PropTypes.array,
    footerHandler: PropTypes.func,
    isActive: PropTypes.func,
    isMobile: PropTypes.bool,
};
export default FooterMiddlePart;
